import { decodeJwt } from 'jose';
import { readMeta } from '../lib/page';
import { readDomainCookie, writeDomainCookie } from './domain_cookie';
import Refresher from '../models/refresher';
import { accountType as originalAccountType, AccountRoles, AccountTypes } from '../models/account';

const refresher = new Refresher({
  now: () => new Date(),
  readMeta,
  readDomainCookie,
  writeDomainCookie,
});

let tokenPromise: Promise<string> | null = null;

export function currentJwt(): any {
  return readDomainCookie('jwt');
}

export function jwtData(): any {
  const token = currentJwt();
  if (!token) return {};

  return decodeJwt(token);
}

export function accountId(): string | null {
  const { sub } = jwtData();

  return sub;
}

export function rolesArray(): string[] {
  const { roles } = jwtData();
  if (!roles) return [];
  return roles;
}

export async function refreshedJwt(): Promise<string | null> {
  let token = currentJwt();
  if (!token) return null;

  if (!refresher.needsRefresh(token)) return token;

  try {
    // Avoids race conditions when multiple calls are occurring
    if (!tokenPromise) {
      tokenPromise = refresher.refresh();
    }

    token = await tokenPromise;
  } catch (error) {
    console.error('Token refresh for graphql request failed', error);
    token = null;
  }

  tokenPromise = null;
  return token;
}

export function accountType(): AccountTypes | null {
  return originalAccountType(rolesArray() as Array<AccountRoles>);
}

export default {
  currentJwt,
  jwtData,
  accountId,
  refreshedJwt,
};
